import VisitsSessionScreen from './VisitsSessionScreen';

export default VisitsSessionScreen;
